/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SurgicalAppointmentAttributeType from './surgical-appointment-attribute-type';
import SurgicalAppointmentAttributeTypeDetail from './surgical-appointment-attribute-type-detail';
import SurgicalAppointmentAttributeTypeUpdate from './surgical-appointment-attribute-type-update';
import SurgicalAppointmentAttributeTypeDeleteDialog from './surgical-appointment-attribute-type-delete-dialog';

const SurgicalAppointmentAttributeTypeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SurgicalAppointmentAttributeType />} />
    <Route path="new" element={<SurgicalAppointmentAttributeTypeUpdate />} />
    <Route path=":id">
      <Route index element={<SurgicalAppointmentAttributeTypeDetail />} />
      <Route path="edit" element={<SurgicalAppointmentAttributeTypeUpdate />} />
      <Route path="delete" element={<SurgicalAppointmentAttributeTypeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SurgicalAppointmentAttributeTypeRoutes;
